import React, { useMemo } from "react";
import CardStats from "../../components/Cards/CardStats";
import TableProduct from "../../components/Table/TableProduct";
import { IStat } from "../../types";
import CardChart from "../../components/Cards/CardChart";
import TablePageVisits from "../../components/Table/TablePageVisits";
import dummyPages from "../../data/pageVisit.json";
import Table from "../../layouts/Table";
import { useFetch } from "../../hooks/useFetch";

const dummyStat: IStat[] = [
  {
    title: "traffic",
    point: 30000,
    percentage: 0.2,
    period: "week",
    icon: "far fa-chart-bar",
    iconColor: "bg-danger",
    to: "insight",
  },
  {
    title: "new users",
    point: 200,
    percentage: 0.1,
    total: 100000,
    period: "week",
    icon: "fas fa-user-plus",
    iconColor: "bg-info",
    to: "user",
  },
  {
    title: "chats",
    point: 2000,
    percentage: -0.1,
    period: "week",
    icon: "fas fa-comment-dots",
    iconColor: "bg-great",
    to: "chat",
  },
  {
    title: "new products",
    point: 200,
    total: 5000,
    percentage: 0.05,
    period: "week",
    icon: "fas fa-inbox",
    iconColor: "bg-fantastic",
    to: "product",
  },
];

export default function HeaderStats() {
  const [result] = useFetch(
    useMemo(() => {
      return {
        startDate: "7daysAgo",
        endData: "today",
        metrics: ["ga:pageviews", "ga:sessions"],
      };
    }, [])
  );

  return (
    <div>
      {/* Header */}

      <div className="grid gap-y-8">
        <CardChart type="line" data={result} />
        {/* Card stats */}
        <div className="grid grid-cols-4 gap-x-4">
          {dummyStat.map((stat: IStat, index: number) => {
            return (
              <CardStats
                point={stat.point}
                period={stat.period}
                icon={stat.icon}
                total={stat.total}
                iconColor={stat.iconColor}
                percentage={stat.percentage}
                title={stat.title}
                key={index}
                to={stat.to}
              />
            );
          })}
        </div>
        <div className="grid grid-cols-6 gap-x-4">
          <Table
            icon="fas fa-boxes"
            className="col-span-3"
            to={"/product"}
            title="Product"
            iconColor="text-emerald-600"
          >
            <TableProduct />
          </Table>
          <Table
            className="col-span-3"
            icon="fas fa-bookmark"
            iconColor="text-purple-500"
            title="Page Visits"
          >
            {" "}
            <TablePageVisits data={dummyPages} />
          </Table>
        </div>
      </div>
    </div>
  );
}
